import { FunctionComponent } from "react";
import {
  StyledAccessibility,
  StyledContainer,
  StyledCopyright,
  StyledFooter,
  StyledGuide,
  StyledLinks,
  StyledLocale,
  StyledLocaleSwitcher,
  StyledOrgName,
  StyledPanel,
  StyledPrivacyPolicy,
  StyledTitle,
  StyledView,
} from "./login-view.styles";
import dayjs from "dayjs";
import { useLocale, useLocales } from "stores/hooks/locale";
import { changeLocale } from "stores/actions/locale";
import { useTranslate } from "stores/hooks/translation";
import { useNavigate } from "react-router";
import { getTranslations } from "lib/translation";
import { useOrganization } from "stores/hooks/organization";
import { parse } from "lib/locale";

interface LoginViewProps {
  children?: any;
  title: string;
  guide?: string | JSX.Element;
  transition: boolean;
  wide?: boolean;
}

const LoginView: FunctionComponent<LoginViewProps> = ({
  children,
  title,
  guide,
  transition,
  wide = false,
}) => {
  const locales = useLocales();
  const translate = useTranslate();
  const navigate = useNavigate();
  const locale = useLocale();
  const organization = useOrganization();

  const openPrivacyPolicy = () => {
    navigate("/privacy-policy");
  };

  const openAccessibility = () => {
    navigate("/accessibility");
  };

  console.info(organization);
  const orgName = organization ? parse(organization.name, locale) : "";

  return (
    <StyledView
      title={title}
      description=""
      navigation={false}
      $transition={transition}
    >
      <StyledContainer $transition={transition}>
        <StyledOrgName level="h2">{orgName}</StyledOrgName>
        <StyledTitle>{title}</StyledTitle>
        <StyledPanel $wide={wide}>
          {guide && <StyledGuide>{guide}</StyledGuide>}
          {children}
        </StyledPanel>
        <StyledFooter>
          <StyledCopyright>
            &copy; {dayjs().year()} Sidonnaisuudet Oy
          </StyledCopyright>
          <StyledLocaleSwitcher>
            {locales.map((loc) => {
              const translation = getTranslations(loc);
              return (
                <StyledLocale
                  key={loc}
                  onClick={() => changeLocale(loc)}
                  $active={loc === locale}
                >
                  {translation[`show_in_locale_${loc}`]}
                </StyledLocale>
              );
            })}
          </StyledLocaleSwitcher>
          <StyledLinks>
            <StyledPrivacyPolicy onClick={openPrivacyPolicy}>
              {translate("privacy_policy")}
            </StyledPrivacyPolicy>
            <StyledAccessibility onClick={openAccessibility}>
              {translate("accessibility")}
            </StyledAccessibility>
          </StyledLinks>
        </StyledFooter>
      </StyledContainer>
    </StyledView>
  );
};

export default LoginView;
